<template>
  <div></div>
</template>

<script>
export default {
  name: 'SessionJump',
  watch: {
    $route: function(to, from) {
      this.init()
    }
  },
  methods: {
    init: function() {
      let step = ''

      if ('step' in this.$route.params) {
        step = this.$route.params.step
      }

      if (step && step.length) {
        this.$store.commit('busy')
        this.$store.dispatch('jump', {step: step})
          .then(session => {
            console.log("Jumped to step '" + step + "'")
            this.$router.replace({name: 'session'})
          })
          .catch(err => {
            console.log(err)

            if (err.response && err.response.status === 400) {
              this.$router.replace({name: 'session'}) // invalid step to jump to - fail silently and stay where we are
            } else if (err.response && err.response.status === 422) {
              // stale session, start a new one at the jump step
              this.$router.replace({name: 'session-start-jump', params: {step: step}})
            } else if (err.response && [301, 302].indexOf(err.response.status) > -1) {
              if ('slug' in err.response.data) {
                this.$router.replace({name: 'session-jump', params: {step: err.response.data.slug}})
              } else {
                this.$store.commit('critical_error', err)
              }
            } else {
              this.$store.commit('critical_error', err)
            }
          })
      } else {
        console.log('Missing step to jump to')
        this.$router.replace({name: 'session'}) // ignore the jump and stay where we are in the session
      }
    }
  },
  created() {
    this.init()
  }
}
</script>

<style scoped>

</style>
